let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dBHBX")).then(() => parcelRequire('bvt68'));